// src/context/TypingContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const TypingContext = createContext(null);

export const TypingProvider = ({ children }) => {
  const [typingMap, setTypingMap] = useState({});

  const setTypingForMatch = useCallback((matchId, isTyping) => {
    setTypingMap(prev => ({
      ...prev,
      [matchId]: isTyping,
    }));
  }, []);

  const clearTypingForMatch = useCallback((matchId) => {
    setTypingMap(prev => {
      const next = { ...prev };
      delete next[matchId];
      return next;
    });
  }, []);

  return (
    <TypingContext.Provider value={{ typingMap, setTypingForMatch, clearTypingForMatch }}>
      {children}
    </TypingContext.Provider>
  );
};

export const useTypingStore = () => {
  const ctx = useContext(TypingContext);
  if (!ctx) {
    throw new Error('useTypingStore must be used inside TypingProvider');
  }
  return ctx;
};
